import { PropsWithChildren } from 'react';

export const Gutter = (props: PropsWithChildren) => <div style={{padding: '0 1em', boxSizing: 'border-box'}}>{props.children}</div>;
